import React from 'react'

import { Link } from 'react-router-dom'
import { reverse } from 'named-urls'

import {
  Box,
  Button,
  Divider,
  Paper,
  Typography,
  Table,
  TableBody,
} from '@material-ui/core'

import helpers from 'helpers'
import { routes } from 'routes'
import { TableDetailRow } from 'components'
import { Permitted } from 'components/Permissions'

const ClientData = ({ isLoading, clientId, editable, data }) => {
  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Dados</Typography>
        <Permitted tag="update_customer">
          {editable ? (
            <Button
              color="primary"
              variant="contained"
              component={Link}
              to={reverse(routes.clients.edit, { clientId })}
            >
              Editar
            </Button>
          ) : null}
        </Permitted>
      </Box>
      <Divider />
      <Table>
        <TableBody>
          <TableDetailRow
            title="Nome"
            value={data.name}
            isLoading={isLoading}
            firstColWidth="30%"
          />
          <TableDetailRow
            title="Email"
            value={data.email}
            isLoading={isLoading}
            firstColWidth="30%"
          />
          {data.cpf && (
            <TableDetailRow
              title="CPF"
              value={helpers.people.formatCpf(data.cpf)}
              isLoading={isLoading}
              firstColWidth="30%"
            />
          )}
          {data.companyName && (
            <TableDetailRow
              title="Razão social"
              value={data.companyName}
              isLoading={isLoading}
              firstColWidth="30%"
            />
          )}
          {data.tradeName && (
            <TableDetailRow
              title="Nome fantasia"
              value={data.tradeName}
              isLoading={isLoading}
              firstColWidth="30%"
            />
          )}
          {data.cnpj && (
            <TableDetailRow
              title="CNPJ"
              value={helpers.people.formatCnpj(data.cnpj)}
              isLoading={isLoading}
              firstColWidth="30%"
            />
          )}
          <TableDetailRow
            key="kind"
            value={data && helpers.people.kind(data.kind)}
            title="Tipo"
            isLoading={isLoading}
            firstColWidth="30%"
          />
          <TableDetailRow
            key="phone"
            value={
              (data && helpers.people.parsePhoneApi(data.contact)) ||
              helpers.people.formatPhone(data.phone)
            }
            title="Telefone"
            isLoading={isLoading}
            firstColWidth="30%"
          />
          {data.code && (
            <TableDetailRow
              title="Código de identificação"
              value={data.code}
              isLoading={isLoading}
              firstColWidth="30%"
            />
          )}
        </TableBody>
      </Table>
    </Paper>
  )
}

export default ClientData
